import 'regenerator-runtime/runtime';
//Utilities
export { default as ApiUtilities } from './src/Utilities/ApiUtilities';
export { default as Middleware } from './src/Utilities/Middleware';
export { default as DownloadUtilities } from './src/Utilities/DownloadUtilities';
//External Libraries
window.One_Ring_Version = '2.4.0';
window.Versions = window.Versions || [];
if (
    window.Versions.findIndex((v) => {
        return v.package === 'one-ring';
    }) < 0
) {
    window.Versions.push({ package: 'one-ring', name: 'One Ring', description: 'API Management', version: window.One_Ring_Version });
}
